@import frontend/shared/stylesheets/environment

.huge-notification-allowlist
  display: none
  position: relative
  max-height: calc(100vh - 100px)
  overflow-y: auto

  background: #fff
  color: $theme-arsenic
  font-size: 16px
  line-height: 1.55

  +media-breakpoint-up(lg)
    +if-ab-test(adblock_allowlisting, b)
      display: block

  p
    margin: 0

.huge-notification-allowlist--hint
  display: flex
  padding: 40px 40px 40px 0

  .huge-notification-allowlist:not(.-mod-on-step-1) &
    display: none

.huge-notification-allowlist--figure-col
  position: relative
  flex: 0 0 16.666%

.huge-notification-allowlist--figure
  position: absolute
  top: 0
  left: 40px
  bottom: -40px
  width: 100%

  background: url('frontend/shared/images/huge_notification/huge_notification_a.webp') no-repeat center bottom
  background-size: contain

.huge-notification-allowlist--hint-text
  flex: 1
  min-width: 0
  padding: 0 15px 0 55px

  display: flex
  flex-direction: column
  gap: 16px

.huge-notification-allowlist--headline
  font-size: 26px
  font-weight: bold
  line-height: 1.3

  &.-mod-balanced
    padding-right: 40px
    text-wrap: balance

.huge-notification-allowlist--points
  display: flex
  flex-wrap: wrap
  gap: 24px
  margin: 4px 0 0
  padding: 0
  list-style: none

  font-size: 14px
  font-weight: 600

  li
    display: flex
    align-items: center
    gap: 6px

  svg
    flex: none
    color: $link-color

.huge-notification-allowlist--actions
  display: flex
  align-items: center
  gap: 24px
  margin-top: 8px

  font-size: 14px

.huge-notification-allowlist--button
  // Outranks the Bootstrap button styles huge_notification.sass compiles in under .huge-notification.
  .huge-notification-allowlist &.btn
    --bs-btn-padding-x: 24px
    --bs-btn-padding-y: 13px
    --bs-btn-font-size: 16px
    --bs-btn-line-height: 1.5
    --bs-btn-border-radius: 26px

.huge-notification-allowlist--link
  +button-link
  +button-hover
  color: $link-color
  font-weight: bold

  &.-mod-back
    font-size: 14px
    display: inline-flex
    align-items: center
    gap: 6px
    align-self: flex-start

.huge-notification-allowlist--steps,
.huge-notification-allowlist--link
  &.-mod-chrome
    .huge-notification-allowlist:not(.-mod-on-step-2-non-safari) &
      display: none

  &.-mod-safari
    .huge-notification-allowlist:not(.-mod-on-step-2-safari) &
      display: none

.huge-notification-allowlist--guide
  display: flex
  flex-direction: column
  gap: 20px
  padding: 32px 40px 40px

  .huge-notification-allowlist.-mod-on-step-1 &
    display: none

.huge-notification-allowlist--steps
  display: grid
  grid-template-columns: 1fr 1fr

  &.-mod-chrome
    gap: 24px

    .huge-notification-allowlist--screenshot
      height: 170px

  &.-mod-safari
    gap: 32px
    align-items: center

    .huge-notification-allowlist--screenshot
      height: 260px

.huge-notification-allowlist--step
  display: flex
  flex-direction: column
  gap: 16px

.huge-notification-allowlist--screenshot
  display: flex
  align-items: center
  justify-content: center
  padding: 16px

  background: $theme-gray
  border-radius: $theme-border-radius-1

  img
    max-width: 100%
    max-height: 100%
    width: auto
    height: auto
    border-radius: 8px
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07), 0 1px 4px rgba(0, 0, 0, 0.05)

.huge-notification-allowlist--instructions
  display: flex
  flex-direction: column
  gap: 24px

.huge-notification-allowlist--instruction
  display: flex
  align-items: flex-start
  gap: 16px

  > :last-child
    padding-top: 6px

.huge-notification-allowlist--number
  flex: 0 0 38px
  height: 38px

  background: $theme-primary-bright
  border-radius: 999px
  color: $link-color
  font-size: 14px
  font-weight: bold
  line-height: 38px
  text-align: center
